import { createFileRoute } from "@tanstack/react-router";

import { TOOL_CARDS } from "@/components/marketing/tools-catalog";
import { ToolsIndex } from "@/components/marketing/tools-index";
import { TOOLS_INDEX_FAQS } from "@/components/marketing/tools-index-faqs";
import { faqJsonLd, pageHead, toolListJsonLd } from "@/lib/seo";

/**
 * `head` is never code-split, so it must not reach into the component module —
 * that would drag the whole page into the shared entry chunk. The FAQs live in
 * their own module for that reason; `tools-catalog` is plain data and only its
 * keys are read here.
 */
export const Route = createFileRoute("/(public)/tools/")({
  head: () =>
    pageHead("tools", {
      jsonLd: [
        faqJsonLd(TOOLS_INDEX_FAQS),
        toolListJsonLd(TOOL_CARDS.map((tool) => tool.key)),
      ],
    }),
  component: ToolsIndex,
});
